import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

interface AlertJsxProps {
  attrs: {
    closeable?: boolean;
    'large-icon'?: boolean;
    'not-fullscreen'?: boolean;
    open?: boolean;
    icon?: string;
    'icon-color'?: string;
  };

  on?: {
    change?: (ev: CustomEvent) => void;
  };
}

export class Alert extends Component<EmptyObj, AlertJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<AlertJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      closeable: `boolean`,
      'large-icon': `boolean`,
      'not-fullscreen': `boolean`,
      open: `boolean`,
      icon: `string`,
      'icon-color': `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        modalChanged: (ev) => this.dispatchEvent(new CustomEvent(`change`, {detail: ev.detail})),
      },
    };
  }
}

export const AlertEl = defineAndMakeJsxFactory<AlertJsxProps>(`mp-alert`, Alert);
